import React, { useMemo } from 'react';
import moment from 'moment';
import Datetime from 'react-datetime';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { Form, InputGroup } from '@themesberg/react-bootstrap';

const toStored = value => {
  if (!value) return '';
  if (moment.isMoment(value)) return value.isValid() ? value.format('YYYY-MM-DD') : '';
  const parsed = moment(value, ['YYYY-MM-DD', 'MM/DD/YYYY', moment.ISO_8601], true);
  if (parsed.isValid()) return parsed.format('YYYY-MM-DD');
  const fallback = moment(value);
  return fallback.isValid() ? fallback.format('YYYY-MM-DD') : '';
};

const toDisplay = value => {
  const stored = toStored(value);
  return stored ? moment(stored).format('MM/DD/YYYY') : '';
};

export default function DatePickerField({
  id,
  name,
  value,
  onChange,
  onBlur,
  disabled = false,
  isInvalid = false,
  placeholder = 'MM/DD/YYYY',
}) {
  const storedValue = toStored(value);
  const selected = useMemo(() => (storedValue ? moment(storedValue) : undefined), [storedValue]);
  const emit = next => {
    if (disabled) return;
    const stored = toStored(next);
    if (stored !== storedValue) onChange(stored);
  };

  return (
    <Datetime
      value={selected}
      timeFormat={false}
      closeOnSelect
      onChange={date => emit(date)}
      inputProps={{ disabled }}
      renderInput={(_props, openCalendar) => (
        <InputGroup className="has-validation">
          <InputGroup.Text
            onClick={disabled ? undefined : openCalendar}
            style={{ cursor: disabled ? 'default' : 'pointer' }}
          >
            <FontAwesomeIcon icon={faCalendarAlt} />
          </InputGroup.Text>
          <Form.Control
            id={id}
            name={name}
            type="text"
            value={toDisplay(value)}
            placeholder={placeholder}
            readOnly
            disabled={disabled}
            isInvalid={Boolean(isInvalid)}
            onFocus={disabled ? undefined : openCalendar}
            onBlur={onBlur}
            onChange={event => emit(event.target.value)}
          />
        </InputGroup>
      )}
    />
  );
}
